import React from 'react';
import { Link } from "gatsby";
import S from './StyledLogo';
import LogoImg from '../../images/nda/logo-NDA-napis.webp'
import AniLink from "gatsby-plugin-transition-link/AniLink"

const Logo = (props) => {
    return ( 
        <>
            <S.LogoWrapper className={!props.isTop ? 'small-logo' : ''}>
                <Link fade to='/'>
                    <img src={LogoImg} alt='nda recz kierownik budowy zachodniopomorskie logo'></img>
                </Link>
            </S.LogoWrapper>
        </>
     );
}
 
export default Logo;